import 'nodelist-foreach-polyfill';
import anime from 'animejs';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { reveal, init, reset } from '../../letters';
import validate from './validate';
import formInputs from './form-inputs';
import { isEditMode } from '../../helpers';
import escapeKey from '../../escape-key';
import captcha from '../../captcha';

const contactForm = {};

const popup = document.querySelector('[data-contact-form-popup]');
const close = document.querySelector('[data-contact-form-close]');
const popupChildren = popup.querySelector('[data-contact-form-popup-children]');

let animation;
let prototypeEl;
let stagger;
let letters;
let opened = false;

function getPrototypeTransform() {
  const rect = prototypeEl.getBoundingClientRect();
  // const top = rect.top - (window.scrollY || document.documentElement.scrollTop);
  return {
    translateY: rect.top,
    scaleY: prototypeEl.clientHeight / popup.clientHeight,
  };
}

anime.set(popup, { transformOrigin: 'center top' });

contactForm.setPrototype = (el) => {
  const formTemplate = document.querySelector(el.dataset.template);
  if (el.dataset.replace !== undefined) {
    let h = formTemplate.innerHTML;
    let mapReplacements = {};
    try {
      mapReplacements = JSON.parse(el.dataset.replace);
    } catch (e) {
      console.error('data-replace should be JSON, given: ', el.dataset.replace);
    }
    Object.keys(mapReplacements).forEach((key) => {
      const re = new RegExp(`%${key}%`, 'g');
      h = h.replace(re, mapReplacements[key]);
    });
    popupChildren.innerHTML = h;
  } else {
    popupChildren.innerHTML = formTemplate.innerHTML;
  }
  prototypeEl = el;
  formInputs(popupChildren);
  validate(popupChildren);
  stagger = [close];
  popupChildren.querySelectorAll('[data-contact-form-stagger]').forEach(el2 => stagger.push(el2));
  letters = popupChildren.querySelectorAll('[data-stagger]');
  letters.forEach(init);
  popupChildren.querySelectorAll('[data-recaptcha-protected]').forEach(form => captcha.protectForm(form));
};

contactForm.openPopup = () => {
  const tl = anime.timeline();
  const pt = getPrototypeTransform();
  if (opened) return;
  opened = true;
  if (animation) {
    animation.pause();
  }
  animation = tl;
  disableBodyScroll(popup);
  anime.set(popup, { visibility: 'visible' });
  letters.forEach(reset);
  setTimeout(() => letters.forEach(reveal), 700);
  tl.add({
    targets: popup,
    translateY: [pt.translateY, 0],
    scaleY: [pt.scaleY, 1],
    duration: 1000,
    easing: 'cubicBezier(.6,0,0,1)',
    opacity: {
      duration: 200,
      easing: 'easeOutQuad',
      value: [0, 1],
    },
  });
  tl.add({
    targets: stagger,
    opacity: [0, 1],
    duration: 300,
    delay: (el, i) => i * 50,
    easing: 'linear',
    complete: () => {
      stagger.forEach(el => el.style.transform = '');
    },
  }, '+=300');
};

contactForm.closePopup = () => {
  if (!opened) return;
  const tl = anime.timeline();
  const pt = getPrototypeTransform();
  opened = false;
  if (animation) {
    animation.pause();
  }
  animation = tl;
  tl.add({
    targets: stagger,
    opacity: 0,
    duration: 200,
    easing: 'easeOutQuad',
  });
  tl.add({
    targets: letters,
    opacity: 0,
    duration: 200,
    easing: 'easeOutQuad',
  }, '-=200');
  tl.add({
    targets: popup,
    translateY: pt.translateY,
    scaleY: pt.scaleY,
    duration: 800,
    easing: 'cubicBezier(.3,0,0,1)',
    opacity: {
      delay: 600,
      duration: 200,
      easing: 'easeOutQuad',
      value: 0,
    },
    complete: () => {
      anime.set(popup, { visibility: 'hidden' });
      letters.forEach(el => el.style.opacity = '');
      enableBodyScroll(popup);
      popup.scrollTop = 0;
    },
  }, '-=100');
};

contactForm.setScrollbarWidth = (width) => {
  if (width !== 0) {
    anime.set(popup, { width: '100vw', paddingRight: width });
  }
};

close.addEventListener('click', () => {
  contactForm.closePopup();
});

contactForm.init = () => {
  if (!isEditMode()) {
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('[data-contact-form-toggle]')) {
        const el = e.target.closest('[data-popup-prototype]');
        contactForm.setPrototype(el);
        setTimeout(() => contactForm.openPopup(), 0);
      }
    });
    escapeKey(() => contactForm.closePopup());
  } else {
    formInputs(document.body);
    validate(document.body);
  }
};

export default contactForm;
